module.exports = __webpack_public_path__ + "img/Employees.54152654.svg";